"use client";

import { twMerge } from "tailwind-merge";
import clsx from "clsx";

import { motion } from "framer-motion";

function Loading({
  direction = "x",
  className1 = "",
  className2 = "",
  style = {},
}) {
  return (
    <div
      style={style}
      className={twMerge(
        clsx(
          `relative ${
            direction === "x" ? "w-full h-1" : "w-1 h-full"
          } rounded-md overflow-hidden`,
          className1,
        ),
      )}>
      <motion.div
        initial={{ [direction]: "-100%" }}
        animate={{ [direction]: "200%" }}
        transition={{
          duration: 1.5,
          ease: [0.6, 0.05, -0.01, 0.9],
          repeat: Infinity,
          repeatType: "reverse",
        }}
        className={twMerge(
          clsx(
            `absolute ${
              direction === "x" ? "h-1 rounded w-1/2" : "h-1/2 rounded-md w-1"
            }`,
            className2,
          ),
        )}></motion.div>
    </div>
  );
}

export default Loading;
